





































import { Component, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import { GetListByCode } from "@/api/configureDictionary";
import { GetEducationPlanList,StartEducationPlan,StopEducationPlan } from "@/api/pdEducationPlan/pdEducationPlan";
import PdEducationPlanAdd from "./pdEducationPlanAdd.vue";
import PdEducationPlanStep from "./pdEducationPlanStep.vue";
@Component({
  components: {
    PdEducationPlanAdd,
    PdEducationPlanStep
  }
})
export default class PdEducationPlanIndex extends AbpBase {
  @Prop() patient: any;
  showAddEducaionPlan: boolean = false;
  showAddEducaionPlanStep: boolean = false;
  loading: boolean = false;
  pdEducationPlan: any = {};
  EducaionPlanRequest: any = {    
    PlanName:"",
    SkipCount: 1,
    MaxResultCount: 10,
    SortKey: "id",
    SortOrder: "asc",
  }
  /**
   * 表格数据
   */
  tableData: any[] = [];
  tableTotalSize: number = 0;
  EducaionPlanDetailed = [
    {
      title: "编号",
      key: "id",
      minWidth: 40
    },
    {
      title: "状态",
      key: "isStartStr",
      minWidth: 40
    },
    {
      title: "计划名称",
      key: "title",
      minWidth: 180
    },
    {
      title: "计划说明",
      key: "description",
      minWidth: 250
    },
    {
      title: "启用时间",
      key: "startTime",
      minWidth: 150,
      render: (h: any, p: any) => {
        return h("span", {}, this.formatDateTime(p.row.startTime));
      }
    },
    {
      title: "停用时间",
      key: "endTime",
      minWidth: 150,
      render: (h: any, p: any) => {
        return h("span", {}, this.formatDateTime(p.row.endTime));
      }
    },
    {
      title: "操作时间",
      key: "lastModificationTime",
      minWidth: 140,
      render: (h: any, p: any) => {
        return h("span", {}, this.formatDateTime(p.row.lastModificationTime));
      }
    },
    {
      title: "操作人",
      key: "optUserName",
      minWidth: 80
    },
    {
      title: "操作",
      key: "",
      minWidth: 120,
      render: (h: any, p: any) => {
        if(p.row.isStart){
          return h("div", [
            h("Button", {
              props: { type: "success", icon: "ios-create", size: "small" },
              style: { marginRight: "5px" },
              domProps: {
                title: "修改"
              },
              on: {
                click: () => {
                  this.onKnowledgeUpdate(p.row);
                }
              }
            }),
            h("Button", {
              props: { type: "info", icon: "ios-add", size: "small" },
              style: { marginRight: "5px" },
              domProps: {
                title: "内容添加"
              },
              on: {
                click: () => {
                  this.onEducationPlanStep(p.row);
                }
              }
            }),
            h("Button", {
              props: { type: "error", icon: "md-close-circle", size: "small" },
              style: { marginRight: "5px" },
              domProps: {
                title: "停用"
              },
              on: {
                click: () => {
                  this.onEducationPlanStop(p.row);
                }
              }
            })
          ]);
        }else{
           return h("div", [
            h("Button", {
              props: { type: "success", icon: "ios-create", size: "small" },
              style: { marginRight: "5px" },
              domProps: {
                title: "修改"
              },
              on: {
                click: () => {
                  this.onKnowledgeUpdate(p.row);
                }
              }
            }),
            h("Button", {
              props: { type: "info", icon: "ios-add", size: "small" },
              style: { marginRight: "5px" },
              domProps: {
                title: "内容添加"
              },
              on: {
                click: () => {
                  this.onEducationPlanStep(p.row);
                }
              }
            }),
            h("Button", {
              props: { type: "primary", icon: "ios-checkmark-circle", size: "small" },
              style: { marginRight: "5px" },
              domProps: {
                title: "启用"
              },
              on: {
                click: () => {
                  this.onEducationPlanStart(p.row);
                }
              }
            })
          ]);
        }
      }
    }
  ];


  async getData() {
    this.loading = true;
    let res = await GetEducationPlanList(this.EducaionPlanRequest);
    this.tableData = res.items;
    this.tableTotalSize = res.totalCount;
    this.loading = false;
  }
  
  onAddEducationPlan() {
    this.pdEducationPlan = {
      id: 0,
      status: true,
      isStart:true,
      titleStr:'新增宣教计划'
    };
    this.showAddEducaionPlan = true;
  }

  //启用宣教记录
  onEducationPlanStart(data: any) {
    this.$confirm("确定要启用吗？", "提示").then(() => {
      this.loading = true;
      StartEducationPlan(data).then(res => {
        this.getData();
      });
      this.loading = false;
    });
  }

  //停用宣教记录
  onEducationPlanStop(data: any) {
    this.$confirm("确定要停用吗？", "提示").then(() => {
      this.loading = true;
      StopEducationPlan(data).then(res => {
        this.getData();
      });
      this.loading = false;
    });
  }

  //修改宣教计划
  onKnowledgeUpdate(data: any) {
    this.pdEducationPlan = data;
    this.pdEducationPlan.titleStr='新增宣教计划'
    this.showAddEducaionPlan = true;
  }

  async ColseDiag() {
    this.showAddEducaionPlan = false;
    await this.getData();
  }

  initDic() {}
  constructor() {
    super();
    this.initDic();
  }
  created() {
    this.getData();
  }
    pageChange(val: any) {
    this.EducaionPlanRequest.SkipCount = val;
    this.getData();
  }

/*   onAddEducaionPlanOk() {
    this.loading = true;
    this.$refs.PdEducationPlanAdd.submit().then(res => {
      if (res) {
        this.showAddEducaionPlan = false;
        this.getData();
      }
    });
    this.loading = false;
  } */
  onSortChange(res: any) {
    this.EducaionPlanRequest.SortKey = res.key;
    this.EducaionPlanRequest.SortOrder = res.order;
    this.getData();
  }

  onEducationPlanStep(data: any){
    this.pdEducationPlan = data;
    this.showAddEducaionPlanStep=true;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdEducationPlan/parts/pdEducationPlan/index.vue